<section class="component-tab component-tab--press component-tab--book-interview tab--book-interview">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 tab-title__col">
				<h2 class="tab__title" *ngIf="bookInterviewData.ib_heading" [innerHtml]="bookInterviewData.ib_heading"></h2>
			</div>
			<div class="col-12 col-md-9 community community__participants-listing">
				<div class="tabbed__intro entry-content">
					<div class="entry-content" [innerHtml]="bookInterviewData.ib_content | safe:'preamble'"></div>
				</div>
				<div class="masonry-section masonry-wrapper">
					<div class="masonry-section masonry-section-js bi-grid row">
						<div class="grid-sizer-3"></div>					
						<div class="col-12 col-sm-6 col-md-4 masonry-item bi-grid-item" *ngFor="let biItems of participant_data">
							<div class="news__link">
								<a class="masonry-link" routerLink="/community/participant/{{ biItems.slug }}">
									<div class="block-tag" *ngIf="biItems.country">
										<b class="tag-head"></b>
										<span [innerHtml]="biItems.country"></span>
									</div>
									<figure class="news__image" *ngIf="biItems.userimage">
										<img alt="biItems.name" class="img-responsive" [defaultImage]="biItems.userimage" [lazyLoad]="biItems.userimage" loading="lazy" width="230" height="230" />
									</figure>
									<figure class="news__image no-image {{ odd ? 'odd-list' : 'even-list' }}" *ngIf="!biItems.userimage"></figure>
									<div class="news__content">
										<h3>{{ biItems.name | titlecase }}</h3>
										<p>
											<span class="bi__position" *ngIf="biItems.position" [innerHtml]="biItems.position"></span>
											<span class="bi__institute" *ngIf="biItems.organisationname"><a href="javascript:void(0);" routerLink="/community/organization/{{ biItems.organisationslug }}">{{ biItems.organisationname }}</a></span>
											<span class="btn btn-press btn-circle" *ngIf="biItems.usertype == 'Press' || biItems.usertype == 'Communications'"><i class="icon-camera"></i> PRESS/COMMS</span>
										</p>
									</div>
								</a>
							</div>						
						</div>
					</div>
					<div class="row" *ngIf="!loadMoreButton && showMoreButton || loadMoreButton">
						<div class="col-12 text-center load-more link-wrapper load-more-large">
							<a href="javascript:;" class="btn btn-bluelight btn-circle link-more" (click)="loadMoreBookInterviewParticipants( offset, limit )" *ngIf="!loadMoreButton && showMoreButton">Show More<span><i class="icon-breadcrumb-bottom"></i></span></a>
							<span *ngIf="loadMoreButton"><span class="loading__circle loading__circle-small"></span></span>								
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>